import React, { useState } from 'react';
import axios from 'axiosInstance';
import { Form, Button, Container, Alert, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../css/AuthLogin.css'; 

const Register = () => {
  const navigate = useNavigate(); 

  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: ''
  });
  const GoLogin = () => {
    navigate('/login'); 
  };
  const [message, setMessage] = useState({ text: '', variant: '' });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(process.env.REACT_APP_BACKEND_URL + '/api/auth/register', form, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      setMessage({ text: '✅ Usuario registrado con éxito', variant: 'success' });

   
      setTimeout(() => {
        sessionStorage.setItem('registeredEmail', form.email);
        navigate('/ResentMessage');
      }, 1000); 
    } catch (error) {
      if (error.response && error.response.data?.errors) {
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0][0];
        setMessage({ text: `❌ ${firstError}`, variant: 'danger' });
      } else {
        setMessage({ text: '❌ Error al registrar usuario', variant: 'danger' });
      }
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <h2 className="Titulo">Registro</h2>

          {message.text && (
            <Alert variant={message.variant}>{message.text}</Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                placeholder="Tu nombre"
                name="name"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Correo electrónico</Form.Label>
              <Form.Control
                type="email"
                placeholder="tucorreo@example.com"
                name="email"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Contraseña segura"
                name="password"
                onChange={handleChange}
                required
              />
            </Form.Group>


            <Button  type="submit" className="boton_accion_user w-100">
              Registrarse
            </Button>
          </Form>
            <div className="mt-3 text-center">
                <Button variant="link" onClick={GoLogin}>
                ¿Ya tienes una cuenta? Inicia sesión
                </Button>
            </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;
